<template>
  <div class="AccountReg">    
    <ATable
      ref="table"
      max-height="672px"
      class-search-container="searchContainer"
      :data="filteredItems"
      :hide-button-insert="currentType < 2"
      :disable_insert="!has_grant_write"
      hide-pagination
      border
      @cell-click="handleCellClick"
      @clicked-create="handleClickedCreate"
    >
      <div slot="search" class="inline">
        <el-radio-group v-model="currentType">
          <el-radio-button :label="1">현금</el-radio-button>
          <el-radio-button :label="2">통장</el-radio-button>
          <el-radio-button :label="3">카드</el-radio-button>
        </el-radio-group>
      </div>
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"            
        :width="$width.indexw"
      />
      <el-table-column
        prop="type_id"
        width="50"
        label="구분"
        :formatter="resolveType"
      />
      <el-table-column
        prop="name"
        width="150"
        label="계좌명"
      >
        <template slot-scope="scope">
          <el-input
            size="mini"
            :readonly="scope.row.id !== editingId"
            v-bind:class="{'readonly-noborder': scope.row.id !== editingId}"
            v-model="scope.row.name"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="currentType > 1"
        prop="bank_name"
        width="100"
        label="은행"
      >
        <template slot-scope="scope">
          <el-input
            size="mini"
            :readonly="scope.row.id !== editingId"
            v-bind:class="{'readonly-noborder': scope.row.id !== editingId}"
            v-model="scope.row.bank_name"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="currentType > 1"
        prop="number"
        width="200"
        :label="resolveAccountNumberTitle()"
      >
        <template slot-scope="scope">
          <el-input
            size="mini"
            :readonly="scope.row.id !== editingId"
            v-bind:class="{'readonly-noborder': scope.row.id !== editingId}"
            v-model="scope.row.number"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="use_flag"
        width="80"
        label="사용"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.id === editingId" >
            <ACheckboxYN
              v-model="scope.row.use_flag"
            />
          </span>
          <span v-if="scope.row.id !== editingId" >
            <i
              class="el-icon-check"
              v-show="scope.row.use_flag === 'Y'"
            />
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="비고"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-input
            size="mini"
            :readonly="scope.row.id !== editingId"
            v-bind:class="{'readonly-noborder': scope.row.id !== editingId}"
            v-model="scope.row.desc"
          />
        </template>
      </el-table-column>
      <el-table-column label="명령" width="150" v-if="has_grant_write">
        <template slot-scope="scope">
          <div v-show="scope.row.id === editingId">
            <el-button type="primary" size="mini" @click="handleClickRegister(scope.row)">저장</el-button>
            <el-button 
              size="mini"
              @click="calcelEditing(scope.row)"
            >취소</el-button>
          </div>
          <div v-show="scope.row.id !== editingId && scope.row.type_id !== 1">
            <el-button type="danger" size="mini" @click="handleClickDelete(scope.row)">삭제</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "AccountReg",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.account"),
      currentType: 1,
      items: [],
      editingId: -1,
      oldItem: null,
      base_data: ['table_account']
    }
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_account", "table_config"]),    
    filteredItems() {
      return this.items.filter(item => {
        return (
          (this.currentType ? item.type_id === this.currentType : true)
        );
      })
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.items = Object.assign([], this.table_account);
    },
    calcelEditing(data) {
      let index = this.items.findIndex(i => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.api.deleteAccount(this.deleteData).then(res => {
        this.handleResponse(res, this.$t('message.success_delete'));
      });
    },
    checkUsed(data) {
      let item = this.table_config.find(c => c.key === 'account');
      if (!item) { return false; }
      let value = item.value;
      if (value.represent !== data.id && value.service !== data.id) { 
        return false; 
      }
      this.util.notify_warning(this, this.title, "계좌설정에 설정된 계좌입니다.");
      return true;

    },
    resolveType(row, column, value) {
      let type = this.system.options.pay_way_flag.find(p => {
        return p.value === value.toString();
      });
      return type ? type.label : '';
    },
    resolveAccountNumberTitle() {
      switch(this.currentType) {
        case 2:
          return '계좌번호';
        case 3:
          return '카드번호';
        default:
          return '';
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (!this.has_grant_write) { return; }
      if (this.editingId > -1) { 
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = {
        id: 0, 
        type_id: this.currentType, 
        name: '',
        bank_name: '',
        number: '',
        use_flag: 'Y',
        desc: null,
      };
      this.items.push(this.oldItem)
    },
    handleCellClick(item, column) {
      if (!this.has_grant_write) { return; }
      if (this.editingId === item.id) { return ; }
      if (this.editingId > -1) { 
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) { return; }
      if (item.type_id === 1) { return; }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      if (!data.name) {
        this.util.notify_warning(this, this.title, "계정명을 입력해 주세요.");
        return;
      }
      if (!data.number) {
        this.util.notify_warning(this, this.title, 
        this.resolveAccountNumberTitle() + "를 입력해 주세요.");
        return;
      }
      let isDuplicated = false;      
      this.items.forEach(item => {        
        if (item.id !== data.id && item.name === data.name) {
          isDuplicated = true;          
        }
      })
      if (isDuplicated) {
        this.util.notify_warning(this, this.title, "중복된 계정명입니다.");
        return;
      }
      if (data.use_flag !== 'Y') {
        if (this.checkUsed(data)) { return; }
      }
      if (data.id) {
        this.api.updateAccount(data).then(res => {
          this.handleResponse(res, this.$t('message.success_update'));
        });        
      } else {
        this.api.createAccount(data).then(res => {
          this.handleResponse(res, this.$t('message.success_create'));
        });
      }
    },
    handleClickDelete(data) {
      if (this.checkUsed(data)) { return; }
      this.deleteData = data;
      this.util.confirm_delete(this, 
        this.title + '[' +  data.name + ']', 
        this.doDelete
      );
    },
    handleResponse(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
    },
  },
}
</script>
